<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 24 19"
>
  <path
    [attr.fill]="color"
    d="M19.604 0L16.258 3.137C14.988 2.709 13.572 2.438 12.015 2.438C4.446 2.438 0 8.989 0 8.989C0 8.989 1.928 11.94 5.146 14.127L2.235 17.036L3.649 18.45L21.019 1.415L19.604 0ZM13.588 5.779C10.3 4.326 6.907 7.687 8.323 10.985L6.597 12.692C4.783 11.532 3.372 10.042 2.537 9.032C4.03 7.384 7.354 4.438 12.015 4.438C12.942 4.438 13.811 4.557 14.625 4.753L13.588 5.779ZM10.705 13.21L15.795 8.217C16.812 11.328 13.792 14.284 10.705 13.21ZM24 8.989C24 8.989 19.748 16.438 12.015 16.438C10.636 16.438 9.353 16.147 8.164 15.701L9.778 14.118C10.493 14.311 11.236 14.438 12.015 14.438C16.806 14.438 20.119 10.911 21.519 9.074C20.79 8.252 19.563 7.084 17.932 6.122L19.421 4.662C22.403 6.562 24 8.989 24 8.989Z"
  />
</svg>
